import urlConfig from '@nexio/emvio-url-config';

const config = {
    local: {
        cognito: {
            APP_CLIENT_ID: '40med6bsrl6uijg2jfg40rbs8i',
            IDENTITY_POOL_ID: 'us-east-1:b0d840fd-6f59-4a62-96c8-ad2aa2704d93',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_VUD7mLycj'
        },
        mixpanel: {
            token: '7cd671d7bb73abfa8af6308163836c48'
        },
        batchApiUrl: 'https://api.nexiopaydev.com/batch/v3',
        kountTransactionUrl: 'https://awc.test.kount.net/workflow/detail.html',
        kount360TransactionUrl: 'https://app-sandbox.kount.com',
        termsAndConditionsUrl: 'https://emvio-email-development.s3.amazonaws.com/Nexio+Agreement.pdf',
        retailIframeUrl: 'https://retail.nexiopaydev.com/dashboard',
        integrationsEmail: 'integrations@nexiopaydev.com',
        launchDarklyClientId: '68e6a42f1398ce09ac8501b1',
        underwritingApiUrl: 'https://underwriting.nexiodev.com/api/v3',
        onlineAppUrl: 'https://onlineapp.nexiopaydev.com/reseller',
        onlineAppMerchantBaseUrl: 'https://onlineapp.nexiopaydev.com'
    },
    test: {
        cognito: {
            APP_CLIENT_ID: '67a8h88helsmrreneotnfkambi',
            IDENTITY_POOL_ID: 'us-east-1:0e34cde6-96b4-4326-85dc-6e45a4324cb1',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_jYIRcJqmj'
        },
        mixpanel: {
            token: 'test'
        },
        batchApiUrl: 'TEST-batchApiUrl',
        kountTransactionUrl: 'TEST-kountTransactionUrl',
        kount360TransactionUrl: 'TEST-kount360TransactionUrl',
        termsAndConditionsUrl: 'fakeurl',
        retailIframeUrl: 'TEST-retailIframeUrl/dashboard',
        integrationsEmail: 'TEST-integrationsEmail',
        launchDarklyClientId: 'darkly-client-id',
        underwritingApiUrl: 'TEST-underwritingApiUrl',
        onlineAppUrl: 'TEST-onlineAppUrl',
        onlineAppMerchantBaseUrl: 'TEST-onlineAppMerchantBaseUrl',
        serviceArns: {
            ach: 'TEST-serviceArns.ach',
            apm: 'TEST-serviceArns.apm',
            auth: 'TEST-serviceArns.auth',
            batch: 'TEST-serviceArns.batch',
            pdf: 'TEST-serviceArns.pdf',
            card: 'TEST-serviceArns.card',
            chargeback: 'TEST-serviceArns.chargeback',
            email: 'TEST-serviceArns.email',
            exports: 'TEST-serviceArns.exports',
            merchant: 'TEST-serviceArns.merchant',
            pay: 'TEST-serviceArns.pay',
            report: 'TEST-serviceArns.report',
            reserve: 'TEST-serviceArns.reserve',
            search: 'TEST-serviceArns.search',
            setting: 'TEST-serviceArns.setting',
            subscription: 'TEST-serviceArns.subscription',
            transaction: 'TEST-serviceArns.transaction',
            user: 'TEST-serviceArns.user',
            webhook: 'TEST-serviceArns.webhook',
            paymentRecovery: 'TEST-serviceArns.paymentRecovery',
            payout: 'TEST-serviceArns.payout'
        },
        blackListedUsernames: ['docs@nexiopay.com']
    },
    development: {
        cognito: {
            APP_CLIENT_ID: '40med6bsrl6uijg2jfg40rbs8i',
            IDENTITY_POOL_ID: 'us-east-1:b0d840fd-6f59-4a62-96c8-ad2aa2704d93',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_VUD7mLycj'
        },
        mixpanel: {
            token: '7cd671d7bb73abfa8af6308163836c48'
        },
        batchApiUrl: 'https://api.nexiopaydev.com/batch/v3', // TODO: update emvio-config with this url when we turn off old batch api
        kountTransactionUrl: 'https://awc.test.kount.net/workflow/detail.html',
        kount360TransactionUrl: 'https://app-sandbox.kount.com',
        termsAndConditionsUrl: 'https://emvio-email-development.s3.amazonaws.com/Nexio+Agreement.pdf',
        retailIframeUrl: 'https://retail.nexiopaydev.com/dashboard',
        integrationsEmail: 'integrations@nexiopaydev.com',
        launchDarklyClientId: '68e6a42f1398ce09ac8501b1',
        underwritingApiUrl: 'https://underwriting.nexiodev.com/api/v3',
        onlineAppUrl: 'https://onlineapp.nexiopaydev.com/reseller',
        onlineAppMerchantBaseUrl: 'https://onlineapp.nexiopaydev.com',
        serviceArns: {
            ach: 'cguhu55zt0',
            apm: '3gob2nr4o1',
            auth: 'knba0m3b8e',
            batch: '1258vkabp5',
            pdf: 'j7p3ip3d1c',
            card: 'plxfhyu7va',
            chargeback: 'vc3driq601',
            email: 'c06dbt9u3c',
            exports: '1ltmfa3ko1',
            merchant: 'nodoybpggi',
            pay: 'rmrq5gf5c7',
            report: 'bfnko8wqt6',
            reserve: 'muxrev1tj9',
            residual: 'knco6k47rc',
            search: '5vmavktp6d',
            setting: 'v8oeboxhv4',
            subscription: 'o0z8c9fvz8',
            transaction: '2lz5ia4ml3',
            user: 'bqu6c9hkvj',
            webhook: '127bn5mfra',
            paymentRecovery: 'vy7qeu8ba1',
            payout: 'mylem7x3ed'
        },
        blackListedUsernames: ['docs@nexiopay.com']
    },
    staging: {
        cognito: {
            APP_CLIENT_ID: '54e8gdl63gtf3ah4fgobulr5f',
            IDENTITY_POOL_ID: 'us-east-1:2cbabd6f-252e-4397-8913-311ac8868055',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_vbSzdK8oO'
        },
        mixpanel: {
            token: '7cd671d7bb73abfa8af6308163836c48'
        },
        batchApiUrl: 'https://api.nexiopaystaging.com/batch/v3',
        kountTransactionUrl: 'https://awc.test.kount.net/workflow/detail.html',
        kount360TransactionUrl: 'https://app-sandbox.kount.com',
        termsAndConditionsUrl: 'https://emvio-email-staging.s3.amazonaws.com/Nexio+Agreement.pdf',
        retailIframeUrl: 'https://retail.nexiopaystaging.com/dashboard',
        integrationsEmail: 'integrations@nexiopaystaging.com',
        launchDarklyClientId: '68e6a447d998e30998bed8d8',
        underwritingApiUrl: 'https://underwriting.nexiostaging.com/api/v3',
        onlineAppUrl: 'https://onlineapp.nexiopaystaging.com/reseller',
        onlineAppMerchantBaseUrl: 'https://onlineapp.nexiopaystaging.com',
        serviceArns: {
            ach: 'phde0tegp7',
            apm: '7er2byjbvg',
            auth: 'xvhrb0fcxb',
            batch: '3btb2sfuj0',
            pdf: 'xzegc7dfkd',
            card: 'e7jg3kitsg',
            chargeback: '0uiihgv1j0',
            email: '1bjv5ujq4j',
            exports: '4jvz0xrxbe',
            merchant: 'ysn38zgbwi',
            pay: 'dkzsg0awz1',
            report: 'tri1lb2c5b',
            reserve: 'uws7u00s0c',
            residual: '7tf511vovg',
            search: 'xb10bc1qzl',
            setting: 'gnqa9o17s8',
            subscription: 'mqc1m4l7fj',
            transaction: 'm0v4rv6of1',
            user: 'jimpxs5a14',
            webhook: 'i0jxlaqcmj',
            paymentRecovery: 'ah0mo83t5m',
            payout: 'uf7qeeukcc'
        },
        blackListedUsernames: ['docs@nexiopay.com']
    },
    production: {
        cognito: {
            APP_CLIENT_ID: '4si89k1m8006t8q8892fefb14e',
            IDENTITY_POOL_ID: 'us-east-1:f8399583-f6e8-4ecd-921a-75d87b5a4831',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_NqT2EyUjZ'
        },
        mixpanel: {
            token: 'b942b29f2e3b2ce6a827d1e865ede562'
        },
        batchApiUrl: 'https://api.nexiopay.com/batch/v3',
        underwritingApiUrl: 'https://underwriting.nex.io/api/v3',
        kountTransactionUrl: 'https://awc.kount.net/workflow/detail.html',
        kount360TransactionUrl: 'https://app.kount.com',
        termsAndConditionsUrl: 'https://emvio-email-production.s3.amazonaws.com/Nexio+Agreement.pdf',
        retailIframeUrl: 'https://retail.nexiopay.com/dashboard',
        integrationsEmail: 'integrations@nex.io',
        launchDarklyClientId: '68e6a2f43a945909bf17ce6e',
        onlineAppUrl: 'https://onlineapp.cmsonline.com/reseller',
        onlineAppMerchantBaseUrl: 'https://onlineapp.cmsonline.com',
        serviceArns: {
            ach: 'pnbz4gki55',
            apm: '1kva5fjhai',
            auth: '5xxqmhnot0',
            batch: 'kvu4tjm5gf',
            pdf: 'uh69v0tmf1',
            card: '77ghb4n94f',
            chargeback: 'kj2nrqqe71',
            email: 'b991whowya',
            exports: '9wtjo4lh0a',
            merchant: 'n2zig1znra',
            pay: '3u3rtof0g4',
            report: 'l4wh98s7ue',
            reserve: 'ev5sdfgojd',
            residual: 'ea41x3tbe5',
            search: '9v0tlzmzkh',
            setting: '8xge43ey9k',
            subscription: 'gqyvdafyc9',
            transaction: 'ry5uwlraia',
            user: 'kzb3i8yerb',
            webhook: 'e1b9vjezfb',
            paymentRecovery: 'cqpxr5ocv9',
            payout: '1uvvxbilv0'
        },
        blackListedUsernames: ['docs@nexiopay.com']
    },
    sandbox: {
        cognito: {
            APP_CLIENT_ID: '2isqo71nk0jtumglj2sm173ms3',
            IDENTITY_POOL_ID: 'us-east-1:f0c46f1b-f34c-450d-a817-f9eaacc00d66',
            REGION: 'us-east-1',
            USER_POOL_ID: 'us-east-1_85ww4iXXR'
        },
        mixpanel: {
            token: '7cd671d7bb73abfa8af6308163836c48'
        },
        batchApiUrl: 'https://api.nexiopaysandbox.com/batch/v3',
        kountTransactionUrl: 'https://awc.test.kount.net/workflow/detail.html',
        kount360TransactionUrl: 'https://app-sandbox.kount.com',
        termsAndConditionsUrl: 'https://emvio-email-sandbox.s3.amazonaws.com/Nexio+Agreement.pdf',
        retailIframeUrl: 'https://retail.nexiopaysandbox.com/dashboard',
        integrationsEmail: 'integrations@nex.io',
        launchDarklyClientId: '68e6a2f43a945909bf17ce6e',
        underwritingApiUrl: 'https://underwriting.nexiosandbox.com',
        onlineAppUrl: 'https://onlineapp.nexiopaysandbox.com/reseller',
        onlineAppMerchantBaseUrl: 'https://onlineapp.nexiopaysandbox.com',
        serviceArns: {
            ach: '3irpev3ma6',
            apm: 'md8kl8wq84',
            auth: 'nobmh5sw8c',
            batch: 'bal5xycit1',
            pdf: 'nhgaqah7tc',
            card: '9ze3bxgf87',
            chargeback: 'pg6mgxoau0',
            email: 't2kfhzdce8',
            exports: 'ewxfwk5p5f',
            merchant: '1hl7g1vyg8',
            pay: 'kl7ae99eca',
            report: '3b53bs5zwa',
            reserve: 'wiuz2mcvw5',
            residual: 'njxclvw719',
            search: '4spkv31mv3',
            setting: 'z3g4hqrpb0',
            subscription: 'rfar03xvth',
            transaction: 'dh96mmsgp3',
            user: '2ngmbxg8wj',
            webhook: 'ykr81ucbcb',
            paymentRecovery: '5hqpl5hc7i',
            payout: 'xm8xgyqa32'
        },
        blackListedUsernames: ['docs@nexiopay.com']
    }
};
export default Object.assign(
    {},
    urlConfig[process.env.BUILD_ENV],
    config[process.env.BUILD_ENV]
);
